import { Message} from '@arco-design/web-react';
import './index.less'
export default Message